module.exports = "/_next/static/images/exchange-6a1e9474ce7388583be79a360a5af7d5.svg";